import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { z } from 'zod'

import { useAuth } from '../../auth-provider/auth-context'
import { API_URL } from '../../constants/constants'

export const vehicleClassSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  order: z.number(),
  weight: z.object({ to: z.number().nullable(), from: z.number().nullable() }),
})

export type VehicleClass = z.infer<typeof vehicleClassSchema>

export const vehicleClassesResponseSchema = z.object({
  items: z.array(vehicleClassSchema),
})

export type VehicleClassesResponse = z.infer<typeof vehicleClassesResponseSchema>

/** All Carma vehicle classes */
export function useVehicleClassesQuery() {
  const auth = useAuth()
  return useQuery({
    queryKey: ['vehicle-classes', 'list'],
    queryFn: async () => {
      if (!auth.token) {
        // This endpoint is unauthenticated, but we've had instances with hackers crawling our JS & trying to call all of the functions
        // No reason to make it easier for them
        throw new Error('No token found')
      }
      const response = await axios.get(`${API_URL}/vehicle-class`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      })
      return vehicleClassesResponseSchema.parse(response.data)
    },
  })
}
